import './InlineInput.f05d518e658a5aa985b1f2f5f6c13ae5.css';
export default {"wrapper":"_wrapper_lpi6c_1","showTooltip":"_showTooltip_lpi6c_1","input":"_input_lpi6c_1"};